// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1663147047520
      var cssReload = require("D:/HBuilderX.3.4.7.20220422/HBuilderX/plugins/uniapp-cli/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  